import { render, staticRenderFns } from "./breaks.vue?vue&type=template&id=d0c70e70&"
import script from "./breaks.vue?vue&type=script&lang=js&"
export * from "./breaks.vue?vue&type=script&lang=js&"
import style0 from "./breaks.vue?vue&type=style&index=0&id=d0c70e70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports